import React from 'react'
import HomePage from '../Components/Utils/HomePage';
import ImageSlider from '../Components/Utils/ImageSlider';
import SliderData from '../Components/Utils/SliderData';

function Home() {
    return (
        <div>
            <ImageSlider slides={SliderData} />;
            <HomePage/>
        </div>
    )
}

export default Home
